import { message } from "antd";
import { TASKID_ERR } from "../../../../constants";

export const TaskIdCheck = () => {
  if (localStorage.getItem("taskId")) {
    return true;
  } else {
    return message.warning(TASKID_ERR);
  }
};
